import { ConfigBadge } from '@/components/status/ConfigBadge';
import { cn } from '@reflex/ui/lib/utils';
import { STATUS_CONFIG } from '@/lib/status-colors';
import type { AgentStatus } from '@/lib/types';
import { AgentHoverPreview } from './AgentHoverPreview';

export function AgentStatusChip({ status, agentId }: { status: AgentStatus; agentId?: string }) {
  const chip = <ConfigBadge config={STATUS_CONFIG} value={status} />;
  if (!agentId) return chip;
  return <AgentHoverPreview agentId={agentId}>{chip}</AgentHoverPreview>;
}

export function AgentStatusDot({ status }: { status: AgentStatus }) {
  return (
    <span
      data-testid="agent-status-dot"
      data-status={status}
      className={cn('inline-block h-2 w-2 rounded-full', STATUS_CONFIG[status].dot)}
    />
  );
}
